module.exports = __webpack_public_path__ + "img/home3.85351cfa.png";